var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcesionarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consecionarios"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3552 65L27.4994 51.4319L23.378 47.5L15.1152 63.9074C14.8089 64.5109 15.1352 65 15.8343 65H20.3485H20.3552ZM64.8848 63.9074L56.6287 47.5L52.5073 51.4319L59.6515 65H64.1657C64.8648 65 65.1911 64.5109 64.8848 63.9074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.4096 32.9673C52.4096 36.463 51.0304 39.6261 48.805 41.9271L39.9967 50.887L31.1884 41.9271C28.963 39.6261 27.5838 36.463 27.5838 32.9673C27.5838 25.9419 33.1406 20.2537 39.99 20.2537C46.8394 20.2537 52.3963 25.9487 52.3963 32.9673M57.5 32.8247C57.5 22.9824 49.6645 15 40.0033 15C30.3422 15 22.5 22.9824 22.5 32.8247C22.5 37.7459 24.4589 42.2054 27.6237 45.4296L36.3987 54.3691L39.0972 57.1182C39.5969 57.6273 40.4031 57.6273 40.8962 57.1182L43.5946 54.3691L52.3696 45.4296C55.5345 42.2054 57.4933 37.7459 57.4933 32.8247",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.8141 32.5C42.8141 34.051 41.5576 35.3141 40 35.3141C38.4424 35.3141 37.1859 34.0576 37.1859 32.5C37.1859 30.9424 38.4424 29.6859 40 29.6859C41.5576 29.6859 42.8141 30.9424 42.8141 32.5ZM47.5 32.5C47.5 28.3573 44.1427 25 40 25C35.8573 25 32.5 28.3573 32.5 32.5C32.5 36.6427 35.8573 40 40 40C44.1427 40 47.5 36.6427 47.5 32.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcesionarios);
export default __webpack_public_path__ + "static/media/Concesionarios.0d6d74f18dafc50134a3be484964f362.svg";
export { ForwardRef as ReactComponent };